import React, { useState, useEffect } from "react";
import goldMedal from '../../../image/medals/gold-medal.png'
import silverMedal from '../../../image/medals/silver-medal.png'
import bronzeMedal from '../../../image/medals/bronze-medal.png'
import MonthYearSelector from './MonthYearSelector';
import { getRanking } from "../../../js/api/rbp";
import LoadingTable from "./LoadingTable";
import { getNumberToCurrency } from '../../../js/helper';

const getRankMedal = (rank) => {
  switch (rank) {
    case 1:
      return <img alt="gold-medal" src={goldMedal} width={38} height={38} />;
    case 2:
      return <img alt="silver-medal" src={silverMedal} width={38} height={38} />;
    case 3:
      return <img alt="bronze-medal" src={bronzeMedal} width={38} height={38} />;
    default:
      return rank;
  }
}

const formatter = getNumberToCurrency();

const Ranking = ({ rankData, promoterData }) => {
  const [rankingData, setRankingData] = useState(rankData);
  const [dataFailed, setDataFailed] = useState(false);
  const [loading, setLoading] = useState(false);
  const [scrollbarWidth, setScrollbarWidth] = useState(0);
  const filterSubmit = async (selectedMonth,selectedYear) => {
    setLoading(true);
    setDataFailed(false);
    const requestParams = {
      params: {
        "user-id": promoterData.userId,
        "month": selectedMonth.value,
        "year": selectedYear.value
      }
    };
    await getRanking(requestParams).then((response) => {
        if (response.data.status === "00") {
          let promoterData = response.data.data;
          setRankingData(promoterData);
        } else {
          setDataFailed(true);
        }
        setLoading(false);
      })
      .catch((error) => {
        setDataFailed(true);
        setLoading(false);
      });
  }

  useEffect(() => {
    const getScrollbarWidth = () => {
      const scrollDiv = document.createElement("div");
      scrollDiv.style.width = "100px";
      scrollDiv.style.height = "100px";
      scrollDiv.style.overflow = "scroll";
      scrollDiv.style.position = "absolute";
      scrollDiv.style.top = "-9999px";
      document.body.appendChild(scrollDiv);

      const width = scrollDiv.offsetWidth - scrollDiv.clientWidth;
      document.body.removeChild(scrollDiv);
      return width;
    };

    setScrollbarWidth(getScrollbarWidth());
  }, []);
  return (
    <>
      <div className="card border-0">
        <div className="card-header">
          Leaderboard
        </div>
        <div className="card-body">
          <div className="row">
            <div className='col-md-12'>
              {rankingData.userRank !== false ? <p className="promoter-rank">Your rank is {rankingData.userRank}/{rankingData.activePromoters}!</p> : ""}
              <p className="rank-content">Here are the top {rankingData.rankCount} ranking promoters</p>
            </div>
          </div>

          <div className="row align-items-end mt-3">
            <div className='col-md-12'>
              <MonthYearSelector startYear={rankingData.startYear} startMonth={rankingData.startMonth} filterSubmit={filterSubmit} loading={loading} />
            </div>
          </div>
          
          <table className="ranking-table table table-sm border mb-0" id={!loading ? "ranking-table" : "loading-table"}>
            <thead>
              <tr style={{ width: `calc(100% - ${scrollbarWidth}px)` }}>
                <th>Rank</th>
                <th>Sales Volume</th>
                <th>Booked</th>
              </tr>
            </thead>
            <tbody>
              {!loading ?
               rankingData.leaderboard.length > 0 && !dataFailed ? rankingData.leaderboard.map((promoter,index) => {
                return (
                  <tr key={index} className='medal-bg gold-bg'>
                    <td className={promoter.rnk > 3 ? "rank-number" : ""}>{getRankMedal(promoter.rnk)}</td>
                    <td>{formatter.format(promoter.VOL)}</td>
                    <td>{promoter.BOOKING}</td>
                  </tr>
                );
              }) : <tr>
                    <td colSpan={4} className="text-center">No Data Found</td>
                  </tr> : <LoadingTable/>
              }
            </tbody>
          </table>
        </div>
      </div>

    </>
  );
};

export default Ranking;
